import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from "."
import { findPanelState } from "../panels"
import type { PanelChangeTo_ } from "../timeline"
import { divergeTimeline, generateElementChange } from "../timeline/transactions"

export const activatePanel: TransactionOperation<
  string,
  PanelChangeTo_[`UPDATE`]
> = (transactors, id) => {
  const { get, set } = transactors
  const panel = get(findPanelState(id))
  const change = generateElementChange(transactors, {
    action: {
      id,
      type: `UPDATE`,
      family: `PANEL`,
      payload: {
        isActive: !panel.isActive,
      },
    },
  }) as PanelChangeTo_[`UPDATE`]
  set(findPanelState(id), (current) => ({
    ...current,
    isActive: !panel.isActive,
  }))

  return change
}

export const activateOnePanel: TransactionOperation<string> = (
  transactors,
  id,
) => {
  const change = activatePanel(transactors, id)
  divergeTimeline(transactors, [change])
}

export const useActivateOnePanel: () => (id: string) => void = () =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => (id) => activateOnePanel(transactors, id),
  )
